export const getHasHighCheckPriority = (user_check_priority: number) => {
  return 0 < user_check_priority
}
